import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";
// import TableDropdown from "components/Dropdowns/TableDropdown.js";

// This is the table constant/Settings which needed to render table elements
export const kodeAkunTable = (handleEdit, handleDelete) => {
  return [
    // {
    //     title: 'Id Sistem Akun',
    //     render: rowData => {
    //         return <span>{rowData.id_sistem_akun}</span>
    //     }
    // },
    {
      title: "Kode Akun",
      render: (rowData) => {
        return <span>{rowData.kode_akun}</span>;
      },
    },
    {
      title: "Nama Akun",
      render: (rowData) => {
        return <span>{rowData.nama_akun}</span>;
      },
    },
    {
      title: "Ref",
      render: (rowData) => {
        return <span>{rowData.ref}</span>;
      },
    },
    {
      title: "N Akun",
      render: (rowData) => {
        return <span>{rowData.n_akun}</span>;
      },
    },
    {
      title: "Saldo Awal",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.saldo_akun_awal)}</span>;
      },
    },
    {
      title: "Akun Sub Child Kategori",
      render: (rowData) => {
        return <span>{rowData.sub_child_kategori_akun}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Updated At",
      render: (rowData) => {
        return <span>{rowData.updated_at}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
          </>
        );
      },
    },
  ];
};
